import * as React from 'react';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useContactLensProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '@grandvisionhq/state';
import '../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../operations/queries/get-frames-by-slug.js';
import '../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '../../../../types/product.js';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import { useDeliveryIntervalOptions } from '../../components/DeliveryIntervalSelect/use-delivery-interval-options.js';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { getActions } from './actions.js';
import { reducer } from './reducer.js';
import { getSelectors } from './selectors.js';
import { getInitialState } from './utils/get-initial-state.js';
import { triggerToastMessage } from './utils/trigger-toast-message.js';

const CLEcommContext = /*#__PURE__*/ React.createContext({});
const useCLEcommContext = ()=>React.useContext(CLEcommContext)
;
const CLEcommProvider = ({ children , maxOrderableQuantity: opcoConfigMaxQuantity  })=>{
    const { activeVariant , selectedPurchaseType  } = useContactLensProductData();
    const { maxQuantityPerVariant , availableSubscriptionIntervals  } = activeVariant;
    const { singleDeliveryIntervalOption  } = useDeliveryIntervalOptions({
        deliveryInterval: null,
        availableSubscriptionIntervals
    });
    const maxOrderableQuantity = !!maxQuantityPerVariant ? maxQuantityPerVariant : opcoConfigMaxQuantity;
    const getInitialStateProps = {
        purchaseType: selectedPurchaseType,
        sortedAttributesSet: activeVariant.prescriptionRanges,
        defaultDeliveryInterval: singleDeliveryIntervalOption === null || singleDeliveryIntervalOption === void 0 ? void 0 : singleDeliveryIntervalOption.value,
        maxOrderableQuantity
    };
    const [state, dispatch] = React.useReducer(reducer, getInitialStateProps, getInitialState);
    const actions = React.useMemo(()=>getActions(dispatch)
    , []);
    const selectors = React.useMemo(()=>getSelectors()
    , []);
    // Update local state when the selected purchase type changes, which will also reset the validations
    React.useEffect(()=>{
        actions.updatePurchaseType(selectedPurchaseType);
    }, [
        actions,
        selectedPurchaseType
    ]);
    React.useDebugValue('CLEcommProvider');
    const value = React.useMemo(()=>({
            actions,
            state,
            selectors,
            maxOrderableQuantity,
            triggerToastMessage
        })
    , [
        actions,
        state,
        selectors,
        maxOrderableQuantity
    ]);
    return /*#__PURE__*/ React.createElement(CLEcommContext.Provider, {
        value: value
    }, children);
};

export { CLEcommContext, CLEcommProvider, useCLEcommContext };
//# sourceMappingURL=CLEcommContext.js.map
